<template>
  <div class="order-submission" style="padding-top: 1rem">
    <!--<navTitle title="下单"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Submit order'
      "
    ></navTitle>


    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo" :num="num"></OrderGoods>
    <div class="wrapper">

      <!--<div class="item">-->
        <!--<div>Customer message</div>-->
        <!--<textarea-->
          <!--placeholder="Please add notes (within 150 words)"-->
          <!--v-model="mark"-->
        <!--&gt;</textarea>-->
      <!--</div>-->
    </div>
    <div class="wrapper">
      <div class="item">
        <div>Payment Method</div>
        <div class="list">

          <div
            class="payItem acea-row row-middle"
            :class="active === 'yue' ? 'on' : ''"
            @click="payItem('yue')"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'yue' ? 'bounceIn' : ''"
              ></div>
              Pay via balance
            </div>
            <div class="tip">Balance available:{{ userInfo.now_money || 0 }}</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'offline' ? 'on' : ''"
            @click="payItem('offline')"
            v-if="offlinePayStatus === 1 && deduction === false"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline' ? 'bounceIn' : ''"
              ></div>
              Offline payment
            </div>
            <div class="tip">Offline payment convenience</div>
          </div>
        </div>
      </div>
    </div>

    <div style="height:1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div>
        Total:
        <span class="font-color-red">{{icon_moeny}}{{ pay_price }}</span>
      </div>
      <div class="settlement" @click="createOrder">Check Out</div>
    </div>
    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.total_price"
      :checked="usableCoupon.id"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>
<style scoped>
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}
.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}
.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  background-image: -webkit-linear-gradient(
    to bottom,
    #e93323 0%,
    #f5f5f5 100%
  );
  background-image: -moz-linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  padding-top: 1rem;
}
.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .allAddress .nav .item {
  width: 3.55rem;
}
.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}
.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "Courier delivery";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}
.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "To the shop to have";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
}
.order-submission .allAddress .nav .item.on2 {
  position: relative;
}
.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "To the shop to have";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}
.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "Courier delivery";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}
.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}
.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}
</style>
<script>
  import { saveOrder,getList } from "@api/raiders";


  import OrderGoods from "@components/RaidersGoods";
import CouponListWindow from "@components/CouponListWindow";
import navTitle from "@components/navTitle";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed, createOrder } from "@api/order";
import { getUser } from "@api/user";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";

const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow,
    navTitle
  },
  props: {},
  data: function() {
    return {
      icon_moeny:this.global.moeny,

      num:1,//下单数量
      pay_price:0,
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      active: _isWeixin ? "weixin" : "yue",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        pay_price: "Loading"
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      userInfo: {},
      bomb_btn:false,
    };
  },
  watch: {
    useIntegral() {
      this.computedPrice();
    },
    $route(n) {
      if (n.name === NAME) {
        this.getUserInfo();
        this.getCartInfo();
      }
    },
    shipping_type() {
      this.computedPrice();
    }
  },
  mounted: function() {
    let that = this;
    that.getUserInfo();
    that.getCartInfo();
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;
  },
  methods: {
    getUserInfo() {
      getUser()
        .then(res => {
          this.userInfo = res.data;
        })
        .catch(() => {});
    },
    addressType: function(index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("No door store information, you can not choose to pick up the store!");
      this.shipping_type = index;
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      const num = this.$route.params.num || 1;
      this.num = num //下单数量
      if (!cartIds) {
        this.$dialog.error("Parameter is wrong");
        return this.$router.go(-1);
      }
      this.$dialog.loading.open("Loading...");
      getList({id:cartIds})
        .then(res => {
          this.$dialog.loading.close();
          this.orderGroupInfo = res.data[0]
          this.pay_price = (1 * this.num).toFixed(2)
        })
        .catch(() => {
          this.$dialog.loading.close();
          this.$dialog.error("Failed to load order data");
        });
    },
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      this.showCoupon = true;
    },
    changeCoupon: function(coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "No coupons", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      this.active = index;
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
    },
    createOrder() {
      let that = this
      let shipping_type = this.shipping_type;
      if (!this.active) return this.$dialog.toast({ mes: "Please select payment method" });

      if(this.bomb_btn){
        return
      }
      this.bomb_btn = true
      this.$dialog.loading.open("Creating order...");
      saveOrder({num:Number(this.num),game_id:this.orderGroupInfo.now_game.id})
        .then(res => {
          this.bomb_btn = false
          this.$dialog.loading.close();
          this.$dialog.success('Place an order successfully')
          setTimeout(function () {
            that.$router.push('/raiders/list/1')
            that.orderGroupInfo = { priceGroup: {} }; //每次使用后销毁防止有缓存
          },2000)
        })
        .catch(err => {
          console.log(err);
          this.bomb_btn = false

          this.$dialog.loading.close();
          this.$dialog.error(err.msg || "Order creation failed");
        });
    }
  }
};
</script>
